// 统一管理 API 和 WebSocket 基础地址
// 从环境变量中读取配置，提供默认值

const ENV_URLS = {
  local: {
    api: 'http://192.168.99.118:22225',
    ws: 'ws://192.168.99.118:22225',
  },
  dev: {
    api: 'https://dev.harvedex.cn',
    ws: 'wss://dev.harvedex.cn',
  },
  test: {
    api: 'https://test.harvedex.cn',
    ws: 'wss://test.harvedex.cn',
  },
  prod: {
    api: 'https://prod.harvedex.cn',
    ws: 'wss://prod.harvedex.cn',
  },
}

function normalizeEnv(raw) {
  const value = String(raw || '').toLowerCase()
  if (value === 'local') return 'local'
  if (value === 'development' || value === 'dev') return 'dev'
  if (value === 'test') return 'test'
  if (value === 'production' || value === 'prod') return 'prod'
  return ''
}

function resolveUrls() {
  // 本地命令：npm run dev / test / prod
  const local = normalizeEnv(import.meta.env.VITE_LOCAL_ENV)
  if (local) return ENV_URLS[local]
  return {
    api: import.meta.env.VITE_API_BASE_URL,
    ws: import.meta.env.VITE_WS_BASE_URL,
  }
}

const urls = resolveUrls()

export const API_BASE_URL = urls.api
export const WS_BASE_URL = urls.ws

// API 超时配置
export const API_TIMEOUT = parseInt(import.meta.env.VITE_API_TIMEOUT) || 15000
export const STORAGE_TIMEOUT = parseInt(import.meta.env.VITE_STORAGE_TIMEOUT) || 30000

// Google Maps 配置
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY

// Mapbox 配置
export const MAP_BOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZ290ZW5nIiwiYSI6ImNtbDk1eDJrdzAwYTUzY3B6bzBwejJrMHkifQ.Sn_H1zFLzt_PylKg8sOtLw'

// 是否开启组织管理
export const OPEN_ORG_MANAGEMENT = true

// 是否显示多工作区功能
export const SHOW_MULTI_WORKSPACE = true

// 是否开启虚拟数据功能
export const ENABLE_VIRTUAL_DATA = true

// 是否能在地图上全量修改元素（含场站上下文：其他 map / 道路 / 通道 / 充电桩等）
// true：PGM/点云下可点选拖动调整；false：仅展示不可编辑
export const ENABLE_FULL_EDIT_ELEMENT = false

// 是否启用连续打点
export const IS_ENABLE_DEVICE_CONTINUOUS_MARK = true

// 验证码长度（与 App 端 verifyCodeLength 对齐，可按环境改为 4 或 6）
export const VERIFY_CODE_LENGTH = 6

/**
 * 声网频道模式。改这里即可切换，无需改业务代码。
 * - rtc：通信模式
 * - live：直播模式
 */
export const AGORA_CHANNEL_MODE = 'live'

/**
 * 声网客户端角色。改这里即可切换。
 * - host：主播（当前，与 mower-mobile 一致；需要发布静音音频才能被其他端看到）
 * - audience：观众
 * 仅 live 模式会调用 setClientRole；rtc 模式没有角色区分。
 */
export const AGORA_CLIENT_ROLE = 'host'

export function isAgoraLiveChannelMode() {
  return AGORA_CHANNEL_MODE === 'live'
}
